import {
  Box,
  DateFormats,
  DescriptionList,
  formatISODate,
  formatNumber,
  Inline,
  Typography,
} from '@omnipresentgroup/design-system';
import type { InvoiceReportEmployee } from '@omnipresentgroup/types';

const NAME = 'Name';
const EMAIL = 'Email';
const JOB_TITLE = 'Job title';
const LOCATION = 'Location';
const SALARY = 'Salary';
const FIRST_PAY_DATE = 'First pay date';
const LAST_PAY_DATE = 'Last pay date';

type Props = {
  employee: InvoiceReportEmployee;
};

export const InvoiceReportEmployeeSummary = ({ employee }: Props) => {
  const InvoiceReportEmployeeSummaryList: {
    label: string;
    value: string | number | JSX.Element;
  }[] = employee
    ? [
        {
          label: NAME,
          value: employee.fullName,
        },
        {
          label: EMAIL,
          value: employee.email,
        },
        {
          label: JOB_TITLE,
          value: employee.role ?? '-',
        },
        {
          label: LOCATION,
          value: employee.country.name,
        },
        {
          label: SALARY,
          value: employee.salary
            ? formatNumber({
                input: Number(employee.salary.amount),
                currency: employee.salary.currency,
              })
            : '-',
        },
        {
          label: FIRST_PAY_DATE,
          value: employee.firstPayDate
            ? formatISODate(employee.firstPayDate, DateFormats.Date)
            : '-',
        },
        {
          label: LAST_PAY_DATE,
          value: employee.lastPayDate
            ? formatISODate(employee.lastPayDate, DateFormats.Date)
            : '-',
        },
      ]
    : [];

  const list = InvoiceReportEmployeeSummaryList.map(({ label, value }) => ({
    header: label,
    detail: (
      <Inline justify="space-between" align="center">
        <Box overflow="auto">
          {typeof value === 'string' ? (
            <Typography size="14" as="span">
              {value}
            </Typography>
          ) : (
            value
          )}
        </Box>
      </Inline>
    ),
  }));

  return (
    <DescriptionList
      list={list}
      id={`employee-summary-details-${employee?.id}`}
    />
  );
};
